import { unescape } from 'html-escaper';
import { DataCountryModel, DataProvinceModel, DataDistrictModel, DataSubdistrictModel } from '.';
import { SYSTEM_LANGUAGES } from '../actions/variables';
import { translate } from '../helpers/frontend';

/*
  type
    0 = บุคคลธรรมดา
    1 = ห้างหุ้นส่วนจำกัด
    2 = บริษัทจำกัด

  branchType
    0 = บุคคลธรรมดา
    1 = สาขาใหญ่
    2 = สาขาย่อย
*/

export class BillingAddressModel {
  constructor(data={}) {
    this._id = data?._id || null;

    this.billingName = data.billingName? unescape(data.billingName): '';
    this.taxId = data.taxId? data.taxId: '';
    
    this.type = data.type? Number(data.type): 0;
    this.branchType = data.branchType? Number(data.branchType): 0;
    this.branchId = data.branchId? unescape(data.branchId): null;

    this.addressLocal = data.addressLocal || SYSTEM_LANGUAGES[0];
    this.address = data.address? unescape(data.address): '';
    this.subdistrict = new DataSubdistrictModel(data.subdistrict || {});
    this.district = new DataDistrictModel(data.district || {});
    this.province = new DataProvinceModel(data.province || {});
    this.country = new DataCountryModel(data.country || {});
    this.zipcode = data.zipcode || '';

    this.addressText = data.addressText? unescape(data.addressText): '';

    this.telephone = data.telephone || '';
    this.instruction = data.instruction? unescape(data.instruction): '';

    this.sameAsShipping = data.sameAsShipping? Number(data.sameAsShipping): 0;

    this.isPrimary = data.isPrimary? Number(data.isPrimary): 0;
    this.isSelected = data.isSelected? Number(data.isSelected): 0;
  }

  isValid() {
    return this.billingName && this.taxId;
  }

  prefixSubdistrict(lang='', langObj={}) {
    if(!lang || lang === 'TH'){
      if(!this.province.name) return 'แขวง / ตำบล';
      else if(this.province.name.includes('กรุงเทพ')) return 'แขวง';
      else return 'ตำบล';
    }else{
      return translate('Subdistrict', langObj);
    }
  }
  prefixDistrict(lang='', langObj={}) {
    if(!lang || lang === 'TH'){
      if(!this.province.name) return 'เขต / อำเภอ';
      else if(this.province.name.includes('กรุงเทพ')) return 'เขต';
      else return 'อำเภอ';
    }else{
      return translate('District', langObj);
    }
  }

  displayAddress(lang='', langObj={},isPDF = false) {
    if(lang === 'TH'){
      return !isPDF ? (<>
        <span>{this.address}</span> <br />
        {this.prefixSubdistrict()}{this.subdistrict.name} {this.prefixDistrict()}{this.district.name} <br />
        {this.province.name} ประเทศ{this.country.name} {this.zipcode}
      </>) : (<>
        {this.address}{' '}
        {this.prefixSubdistrict()}{this.subdistrict.name} {this.prefixDistrict()}{this.district.name} <br />
        {this.province.name} ประเทศ{this.country.name} {this.zipcode}
      </>
      )
    }else if(lang === 'EN'){
      return (<>
        <span>{this.address}</span> <br />
        Subdistrict {this.subdistrict.name}, District {this.district.name} <br />
        {this.province.name}, {this.country.name} {this.zipcode}
      </>);
    }else{
      return (<>
        <span>{this.address}</span> <br />
        {this.prefixSubdistrict(lang, langObj)} {this.subdistrict.name},
        {' '}{this.prefixDistrict(lang, langObj)} {this.district.name} <br />
        {translate('Province', langObj)} {this.province.name}, {this.country.name} {this.zipcode}
      </>);
    }
  }
  displayAddressLine(lang='', langObj={}) {
    if(lang === 'TH'){
      return (<>
        {this.address}
        {' '}{this.prefixSubdistrict()}{this.subdistrict.name} {this.prefixDistrict()}{this.district.name}
        {' '}{this.province.name} ประเทศ{this.country.name} {this.zipcode}
      </>);
    }else if(lang === 'EN'){
      return (<>
        {this.address}
        {', '}Subdistrict {this.subdistrict.name}, District {this.district.name}
        {', '}{this.province.name}, {this.country.name} {this.zipcode}
      </>);
    }else{
      return (<>
        {this.address}
        {', '}{this.prefixSubdistrict(lang, langObj)} {this.subdistrict.name}
        {', '}{this.prefixDistrict(lang, langObj)} {this.district.name}
        {', '}{translate('Province', langObj)} {this.province.name}, {this.country.name} {this.zipcode}
      </>);
    }
  }

  displayPrimary(langObj={}) {
    if(this.isValid()){
      if(this.isPrimary === 1) return (<span className="ss-tag bg-success">{translate('Yes', langObj)}</span>);
      else return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
    }else{
      return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
    }
  }
  displaySelected(langObj={}) {
    if(this.isValid()){
      if(this.isSelected === 1) return (<span className="ss-tag bg-success">{translate('In Use', langObj)}</span>);
      else return (<span className="ss-tag bg-warning">{translate('Not In Used', langObj)}</span>);
    }else{
      return (<span className="ss-tag bg-warning">{translate('Not In Used', langObj)}</span>);
    }
  }
  displayType(langObj={}) {
    if(this.isValid()){
      if(this.type === 0) return translate('Individual', langObj);
      else if(this.type === 1) return translate('Limited Partnership', langObj);
      else if(this.type === 2) return translate('Limited Company', langObj);
      else return '';
    }else{
      return '';
    }
  }
  displayBranchType(langObj={}) {
    if(this.isValid()){
      if(this.branchType === 1) return translate('Main Branch', langObj);
      else if(this.branchType === 2) return translate('Sub Branch', langObj);
      else return '';
    }else{
      return '';
    }
  }
}
